import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SimButtonModule } from '@simOn/ui/sim-button';
import { SimIconComponent } from '@simOn/ui/sim-icon';
import { SimMenuPanelModule } from '@simOn/ui/sim-menu-panel';
import { EllipsisTooltipDirective } from '@simOn/ui/sim-tooltip';
import { SimSidePanelComponent } from '../side-panel/side-panel.component';

@Component({
  selector: 'sim-detail-panel',
  standalone: true,
  imports: [SimSidePanelComponent, SimIconComponent, SimButtonModule, SimMenuPanelModule, EllipsisTooltipDirective],
  templateUrl: './detail-panel.component.html',
  styleUrl: './detail-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimDetailPanelComponent {
  readonly icon = input<string>('');
  readonly thumbnailUrl = input<string | null>(null);
  readonly iconSizeInPx = input(20);
  readonly heading = input<string>('');
  readonly canEdit = input<boolean>(false);

  readonly closePanel = output<void>();
  readonly edit = output<void>();
  readonly remove = output<void>();
}
